import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { newAuthService } from "Service/Axios";
import { copyOfferLetterUrl } from "Constant/api";
import { Validator } from "Utils/validator";

export const CopyOfferLetter = ({ show, data, toggle, listing }) => {
  const { t } = useTranslation();

  const defaultEventData = {
    offerLetterName: "",
    category: "",
  };
  const [formData, setFormData] = useState(defaultEventData);

  const [errMsg, setErrMsg] = useState({
    offerLetterName: "",
    category: "",
  });

  const { offerLetterName, category } = formData;

  useEffect(() => {
    if (data) {
      setFormData({
        offerLetterName: data.name,
        category: data.category,
      });
    }
  }, [data]);

  // On Change
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }

    if (e.target.name === "offerLetterName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          offerLetterName: t(
            "common.messages.error.offerLetter.offerLetterName.blank"
          ),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          offerLetterName: "",
        }));
      }
    }

    if (e.target.name === "category") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          category: t("common.messages.error.offerLetter.category.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          category: "",
        }));
      }
    }
  };

  // Validation
  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(offerLetterName) && Validator.text(category)) {
        resolve(true);
      } else {
        if (!Validator.text(offerLetterName)) {
          setErrMsg((prev) => ({
            ...prev,
            offerLetterName: t(
              "common.messages.error.offerLetter.offerLetterName.blank"
            ),
          }));
        }

        if (!Validator.text(category)) {
          setErrMsg((prev) => ({
            ...prev,
            category: t("common.messages.error.offerLetter.category.blank"),
          }));
        }

        resolve(false);
      }
    });
  };

  // Submit & Reset
  const onSubmit = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          name: offerLetterName,
          category,
        };
        if (data.gid) {
          payload.gid = data.gid;
        }
        const response = await newAuthService(
          copyOfferLetterUrl,
          "POST",
          payload
        );
        if (response.status) {
          toast.success(
            t("common.messages.notification.success.copyOfferLetter")
          );
          listing();
          toggle();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">{t("auth.offerLetter.copyOfferLetter")}</h5>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="offerLetterName" className="form-label">
            Offer Letter Name
          </label>
          <input
            className="form-control"
            type="text"
            placeholder=""
            id="offerLetterName"
            name="offerLetterName"
            value={offerLetterName}
            onChange={handleChange}
          />
          {errMsg.offerLetterName && (
            <p className="error">{errMsg.offerLetterName}</p>
          )}
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div className="mb-3">
            <label htmlFor="category" className="form-label">
              Offer Letter Category
            </label>
            <input
              className="form-control"
              type="text"
              placeholder=""
              id="category"
              name="category"
              value={category}
              onChange={handleChange}
            />
            {errMsg.category && <p className="error">{errMsg.category}</p>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={toggle}
        >
          {t("common.button.cancel")}
        </button>
        <button type="button" className="btn btn-primary" onClick={onSubmit}>
          {t("common.button.save")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
